<template>
  <v-footer
    color="gray-50"
    class="py-8 py-md-16 px-0 flex-grow-0"
  >
    <v-container class="d-flex flex-column ga-10">
      <v-row class="text-gray-500">
        <v-col
          cols="12"
          md="12"
          lg="4"
          align-self="center"
          class="d-flex flex-column ga-2"
        >
          <div class="d-flex flex-column ga-1">
            <ui-logo :width="138" />
            <div class="text-subtitle-2">
              Inspirujemy do rozwoju
            </div>
          </div>
          <div class="d-flex flex-row align-center flex-wrap ga-2 text-gray-600">
            <csm-ui-social-media />
          </div>
        </v-col>
        <v-col
          cols="12"
          md="6"
          lg="4"
        >
          <h2 class="text-subtitle-3 text-gray-900 font-weight-medium">
            Adres
          </h2>
          <span>
            Misja Chrześcijańska Służba Muzyczna<br>
            ul. Biery 285<br>
            43-386 Biery
          </span>
        </v-col>
        <v-col
          cols="12"
          md="6"
          lg="4"
        >
          <h2 class="text-subtitle-3 text-gray-900 font-weight-medium">
            Kontakt
          </h2>
          <span>
            +48 513-243-073<br>
            kontakt@csmonline.edu.pl
          </span>
        </v-col>
      </v-row>

      <v-divider color="gray-200" />

      <div class="d-flex flex-column flex-md-row align-center ga-4 text-gray-400">
        <div class="text-subtitle-3">
          Copyright &copy; {{ new Date().getFullYear() }}
          Misja CSM
        </div>
        <v-spacer v-if="$vuetify.display.mdAndUp" />
        <div class="d-flex align-center flex-column ga-4 flex-sm-row ga-sm-6">
          <csm-ui-link
            to="/regulamin"
            text="Regulamin"
          />
          <csm-ui-link
            :to="'/regulamin#polityka-prywatnosci'"
            text="Polityka Prywatności"
          />
          <csm-ui-link
            :to="'/#faq'"
            text="FAQ"
          />
          <csm-ui-link
            target="_blank"
            href="https://csm.edu.pl/pdfs/statut.pdf"
            text="Statut"
          />
          <csm-ui-link
            target="_blank"
            href="https://csm.edu.pl/pdfs/standardy-ochrony-maloletnich.pdf"
            text="Standardy Ochrony Małoletnich"
          />
        </div>
      </div>
    </v-container>
  </v-footer>
</template>
